import React from "react";
import { TOOL_TEMPLATE } from "../constant/common";
import {
  useCompanySettings,
  useTemplateSetting,
} from "../hooks/useCompanySettings";
import i18n from "@euroland/libs/locale/i18n";
import { classNames } from "../utils";
import Icon from "./ui/Icon";
import Label from "./ui/Label";
import { Tooltip } from "@euroland/react-tooltip";


/**
 * @typedef {() => JSX.Element | nul } IButtonWillRender function because we want lazy init component
 */

const appSettings = window.appSettings;

function ButtonAction({iconName, title, ...props}) {
  return <Tooltip right={!appSettings.isRtl} label={title}><a {...props}><Icon name={iconName} className={iconName}></Icon></a></Tooltip>
}

function ButtonActionVictor({iconName, title, ...props}) {
  return <a {...props}>
    <span className="icon-container"><Icon name={iconName} className={iconName}></Icon></span>
    <span className="action-name">{title}</span>
  </a>
}

const DownloadButton = () => {
  const template = useTemplateSetting();
  const settings = useCompanySettings();

  /** @type { IButtonWillRender } */
  let buttonWillRender = null;

  const downloadOption = (type) => {
    const isPreviewParam = appSettings.isPreview ? "&isPreview" : "";
    if (type === "excel") {
      let url = `download/excel?companyCode=${appSettings.companyCode
        }&lang=${appSettings.language}${appSettings.companyCodeVersion
          ? "&v=" + appSettings.companyCodeVersion
          : ""
        }`;
      return url + isPreviewParam;
    }
    if (type === "pdf") {
      let url = `?companyCode=${appSettings.companyCode}&lang=${appSettings.language
        }${appSettings.companyCodeVersion
          ? "&v=" + appSettings.companyCodeVersion
          : ""
        }&action=pdfDownload`;
      return url + isPreviewParam;
    }
  };
  const buttonLoad = (child, downloadtype) => {
    return (
      <>
        <td>
          {downloadtype === "print" ? (
            <a
              rel="Print page"
              role="button"
              tabIndex="0"
              onClick={() => window.print()}
              onKeyPress={() => window.print()}
              className={classNames("btn-options", { "button button--primary": template === TOOL_TEMPLATE.quadrata })}
            >
              {child}
            </a>
          ) : (
            <a
              rel={downloadtype + " page"}
              href={downloadOption(downloadtype)}
              className={classNames("btn-options", { "button button--primary": template === TOOL_TEMPLATE.quadrata })}
            >
              {child}
            </a>
          )}
        </td>
      </>
    );
  };
  switch (template) {
    case TOOL_TEMPLATE.victor:
      buttonWillRender = (downloadtype) => {
        const child = (
          <>
            <Icon name={downloadtype} className={downloadtype} />
            <Label className="label-icon">{i18n.translate(downloadtype)}</Label>
          </>
        );
        return <>{buttonLoad(child, downloadtype)}</>;
      };
      break;
    case TOOL_TEMPLATE.quadrata:
      buttonWillRender = (downloadtype) => {
        let type;
        switch (downloadtype) {
          case "print":
            type = "printPage";
            break;
          case "pdf":
            type = "downloadPdf";
            break;
          case "excel":
            type = "downloadExcel";
            break;
          default:
            type = null;
            break;
        }
        const child = <>{i18n.translate(type)}</>;
        return <>
          <button><Icon name="excel-icon" className="excel-icon"></Icon></button>
        </>;
      };
      break;
    // eslint-disable-next-line no-fallthrough
    default:
      // we don't render any thing if template don't match
      return null;
  }

  const enableVictorItems = (
      <>
        {settings.enablePrint && <ButtonActionVictor
          className="action-print"
          iconName={'print-icon'}
          rel={i18n.translate('print')}
          title={i18n.translate('print')}
          role="button"
          label="Print page"
          aria-label="Print page"
          tabIndex="0"
          onClick={() => window.print()}
          onKeyPress={() => window.print()}
        />}
        {settings.enableExcelDownload && <ButtonActionVictor
          className="action-excel"
          iconName={'excel-icon'}
          rel={i18n.translate('excel')}
          title={i18n.translate('excel')}
          role="button"
          label="Download Excel"
          aria-label="Download Excel"
          href={downloadOption('excel')}
        />}
      </>
  );

  const enableItems = (
      <>
        {settings.enablePrint &&  <ButtonAction
          iconName={'print-icon'}
          rel={i18n.translate('printPage')}
          title={i18n.translate('printPage')}
          role="button"
          tabIndex="0"
          aria-label={i18n.translate('printPage')}
          onClick={() => window.print()}
          onKeyPress={() => window.print()}
        />}
        {settings.enableExcelDownload && <ButtonAction
          iconName={'excel-icon'}
          rel={i18n.translate('downloadExcel')}
          title={i18n.translate('downloadExcel')}
          aria-label={i18n.translate('downloadExcel')}
          role="button"
          href={downloadOption('excel')}
        />}
      </>
  );
  const victorDownloadPage = (
    <div>

      <div className="download-options-list print-none">{enableVictorItems}</div>
    </div>
  );
  const quadrataDownloadPage = (
    <div className="print-content print-none">
      <div className="quad-options-list">
        {enableItems}
      </div>
    </div>
  );
  return (
    <>
      {template === TOOL_TEMPLATE.victor && victorDownloadPage}
      {template === TOOL_TEMPLATE.quadrata && quadrataDownloadPage}
    </>
  );
};

export default DownloadButton;
